import React from 'react'
import RecordForm from '../../../../../../generic/universal-table/components/RecordForm/RecordForm'
import { PalletUiRow } from '../types/palletTable.types'

type PalletFormProps = React.ComponentProps<typeof RecordForm<PalletUiRow>>

// Thin module-named wrapper so AppModal has a stable `Children` seam (and a place for
// any future pallet-specific glue). All logic lives in the unified RecordForm.
const PalletForm = (props: PalletFormProps) => <RecordForm<PalletUiRow> {...props} />

export default PalletForm
